// extracted by mini-css-extract-plugin
export default {"memberRow":"MemberRow-module--memberRow--cSfpb","name":"MemberRow-module--name--8Hqq-","email":"MemberRow-module--email--UyDZV","orgTag":"MemberRow-module--orgTag--05uvu"};